// Production environment - these are SAFE FALLBACK values (dev/staging)
// Actual production values will be injected by EnvironmentService from Docker environment variables
// Using dev/staging as fallback is safer than production values
export const environment = {
  production: true,
  hmr: false,
  buildVersion: 'BUILD_VERSION_PLACEHOLDER', // Will be replaced during build
  apiUrl: 'https://api.peopleflow.sk/', // Safe fallback - will be overridden by API_URL env var
  openApiUrl: 'https://api.peopleflow.sk/openapi/', // Safe fallback - will be overridden by OPEN_API_URL env var
  dashboardUrl: 'https://app.peopleflow.sk/', // Safe fallback - will be overridden by DASHBOARD_URL env var
  // Google Maps API Key - for staging environment
  // Production/Staging: Set GOOGLE_MAPS_API_KEY environment variable in Docker
  googleMapsApiKey: '',
  firebase: {
    // Fallback Firebase config - will be overridden by Docker environment variables
    apiKey: '',
    authDomain: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
  },
  legal: {
    termsOfUseUrl: 'https://www.peopleflow.sk/terms-of-use', // Safe fallback - will be overridden by TERMS_OF_USE_URL env var
    privacyPolicyUrl: 'https://www.peopleflow.sk/privacy-policy', // Safe fallback - will be overridden by PRIVACY_POLICY_URL env var
  },
};
